import { OdataFilterOperatorEnum } from 'api/odata'
import { search } from 'api/search'
import axios from 'axios'
import { IApiOptions } from 'shared/contracts/IApiOptions'
import {
  IBreakDetailAttrCountRes,
  IDQRActionsRequest,
  IInsertUpdateSuppressMessageApiReq,
  IInsertUpdateSuppressMessageApiRes,
  IReconDetailsReq,
  IReconDetailsRes,
  ISetAPIResponseOutput
} from './types'

const fetchReconDetailsService = (
  req: IReconDetailsReq,
  options: IApiOptions
) => {
  const url = `${options.apiRoot}/cdmRecon/datarecon/Getdqrdetails`
  const headers = {
    Authorization: `Bearer ${options.accessToken}`
  }
  return axios
    .post<IReconDetailsRes>(url, req, {
      headers,
      cancelToken: options.cancelToken
    })
    .then((res) => res.data)
}
const postReconAddCommentsService = (
  req: IDQRActionsRequest,
  options: IApiOptions
) => {
  const url = `${options.apiRoot}/cdmRecon/DataRecon/setDashboardActions`
  const headers = {
    Authorization: `Bearer ${options.accessToken}`
  }
  return axios
    .post<ISetAPIResponseOutput>(url, req, {
      headers,
      cancelToken: options.cancelToken
    })
    .then((res) => res.data)
}

const postSEIReconAddCommentsService = (
  req: IDQRActionsRequest,
  options: IApiOptions
) => {
  const url = `${options.apiRoot}/cdmRecon/DataRecon/setSEIDashboardActions`
  const headers = {
    Authorization: `Bearer ${options.accessToken}`
  }
  return axios
    .post<ISetAPIResponseOutput>(url, req, {
      headers,
      cancelToken: options.cancelToken
    })
    .then((res) => res.data)
}

const postReconSuppressService = (
  req: IInsertUpdateSuppressMessageApiReq,
  options: IApiOptions
) => {
  const url = `${options.apiRoot}/cdmRecon/datarecon/suppress`
  const headers = {
    Authorization: `Bearer ${options.accessToken}`
  }
  return axios
    .post<IInsertUpdateSuppressMessageApiRes>(url, req, {
      headers,
      cancelToken: options.cancelToken
    })
    .then((res) => res.data)
}
const fetchBreakDetailAttrService = (options: IApiOptions) => {
  const url = `${options.apiRoot}/cdmRecon/datarecon/GetBreakDetailAttr`
  const headers = {
    Authorization: `Bearer ${options.accessToken}`
  }
  return axios
    .get<IBreakDetailAttrCountRes>(url, {
      headers,
      cancelToken: options.cancelToken
    })
    .then((res) => res.data)
}

const fetchResolvedCountService = (options: IApiOptions) => {
  return search(
    'dqrbreakdetail',
    {
      count: true,
      top: 0,
      filters: [
        {
          and: [
            {
              type: 'string',
              operator: OdataFilterOperatorEnum.searchin,
              path: 'breakStatus',
              value: ['Resolved']
            },
            {
              type: 'string',
              operator: OdataFilterOperatorEnum.searchin,
              path: 'reconSystemCode',
              value: ['SA_RECON']
            }
          ]
        }
      ]
    },
    options
  ).then((res) => res['@odata.count'] || 0)
}

export {
  fetchReconDetailsService,
  postReconAddCommentsService,
  postSEIReconAddCommentsService,
  postReconSuppressService,
  fetchBreakDetailAttrService,
  fetchResolvedCountService
}
